import React from "react";

import { IActiveLearningIssue } from "../../../../../state";
import SaveAnswerButton from "../../../../../atoms/ActiveLearning/SaveAnswerButton";
import Issue1 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson9/Material/Issue1";
import styles from "../../ActiveLearningLesson.module.scss";

type Lesson9MaterialProps = {
  findIssue?: (no: number) => IActiveLearningIssue | undefined;
};

export const Lesson9Material = (props: Lesson9MaterialProps) => {
  return (
    <>
      <div className={styles.section}>
        <Issue1 issue={props.findIssue && props.findIssue(1)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
    </>
  );
};
export default Lesson9Material;
